<script setup lang="ts">
defineProps({
  active: { type: Number, required: true },
  isAuthenticated: { type: Boolean, default: true }
})

const tabs = [
  {
    title: 'Following',
    link: '/forum/feed'
  },
  {
    title: 'For you',
    link: '/forum/feed/for-you'
  }
]
</script>

<template>
  <div id="feed-header">
    <CommonPageHeader title="Feed" search @click-search="navigateTo('/forum/search')">
      <CommonButton icon small href="/forum/post/add">
        <CommonIconForumWrite />
        <span> New post</span>
      </CommonButton>
    </CommonPageHeader>

    <div v-if="isAuthenticated" id="feed-header-tab">
      <PageForumTabs :tabs="tabs" :active="active" />
    </div>
  </div>
</template>

<style scoped lang="scss">
#feed-header {
  &-tab {
    margin-top: 25px;
    /* display: flex; */
    /* gap: 30px; */
  }
}
/* 
.header-item {
  font-weight: 500;
  color: var(--textM2);
  position: relative;
}

.header-item::before {
  position: absolute;
  content: '';
  background: black;
  height: 2px;
  bottom: -4px;
  left: 0;
  border-radius: 5px;
  width: 50%;
  display: none;
  animation: grow 0.3s ease-out;
}

.header-item-active {
  color: var(--black);
}

.header-item-active::before {
  display: block;
}

@keyframes grow {
  0% {
    width: 0;
  }
  100% {
    width: 50%;
  }
} */
</style>
